import { styled } from '@mui/material';

import { Button } from '../Button';
import { Typography } from '../Typography';

export const SelectGhostMobileButtonStyled = styled(Button)(({ theme }) => ({
  width: '100%',
  height: 44,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  margin: 0,
  gap: theme.spacing(2),
  padding: theme.spacing(0, 4),
  textOverflow: 'ellipsis',
  border: 'none',
  borderRadius: theme.spacing(0),
  backgroundColor: 'transparent',
  textTransform: 'none',
  borderBottom: `1px solid ${theme.palette.divider}`,

  '& .MuiTypography-button1': {
    width: '100%',
    height: 44,
    justifyContent: 'space-between',
    gap: 0,
    textTransform: 'none',
    padding: 0,
  },

  '&:hover': {
    border: 'none',
    borderRadius: theme.spacing(0),
    backgroundColor: 'transparent',
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
}));

export const SelectGhostButtonValue = styled(Typography)(({ theme }) => ({
  minWidth: 0,
  marginLeft: theme.spacing(1),
  display: 'block',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
}));
